import { changeSortby, fetchSortby } from '@/api/api.APP_TARGET';

/*
const setLanguage = ({ commit }, language) => {
  return changeLanguage(language)
  .then(lang => commit('SET_LANGUAGE', lang))
}

const getLanguage = ({ commit, state }) => {
  if (!state.language) {
    return fetchLanguage()
    .then(language => changeLanguage(language))
    .then(lang => commit('SET_LANGUAGE', lang))
  }
}
*/

const getSortby = ({ commit }) => {
  return fetchSortby().then((type) => {
    commit('SET_SORTBY', type);
  });
};

const setSortby = ({ commit }, type) => {
  return changeSortby(type).then((t) => commit('SET_SORTBY', t));
};

const setWrapperSize = ({ commit }, size) => {
  commit('SET_WRAPSIZE', size);
};

const setEnableSound = ({ commit }, mode) => {
  commit('SET_ENABLESOUND', mode);
};

const setSessionExpired = ({ commit }) => {
  commit('SET_SESSIONEXPIRED');
};

export default {
  // setLanguage,
  setSortby,
  setWrapperSize,
  // getLanguage,
  getSortby,
  setEnableSound,
  setSessionExpired,
};
